import { ValidatorFn, FormGroup } from '@angular/forms';

/**
 * Formats the data for dropdown, changes i.e {itemName:abcd,ItemId:123} to {label:abcd,value:123}
 * usage - formatDataForDropDown(listOfItems, 'itemName','ItemId');
 * @param {array} listOfItems - List of items for the dropdown.
 * @param {string} label - Key Name of the label.
 * @param {string} value - key Name of the value.
 */
export function formatDataForDropDown(listOfItems:any, label:any, value:any) {
  let ddOptions = [];
  for (const item in listOfItems) {
    let itemToBePushed:any = {};
    itemToBePushed['label'] = listOfItems[item][label];
    itemToBePushed['value'] = listOfItems[item][value];
    ddOptions.push(itemToBePushed);
  }
  return ddOptions;
}

